import React from 'react';
import PropTypes from 'prop-types';
import ViewQuilt from '@mui/icons-material/ViewQuilt';
import { useTranslation } from 'react-i18next';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import DocumentTemplateSignatureHeaderComponent from './DocumentTemplateSignatureHeaderComponent';

const DocumentTemplateSignatureHeaderCard = ({
  documentTemplate,
  signatureTypes,
  requiredDocTypes,
  onSelectedClick,
  onImplicitClick,
  onPropertyChanged,
  onSave,
  onDocumentTemplateNeedsSigningChanged,
  validation
}) => {
  const [t] = useTranslation();

  return (
    <Card
      icon={ViewQuilt}
      iconColor='primary'
      title={t('DocumentTemplate.SignatureTypes')}
      actions={
        <IconButton
          color='transparent'
          type='save'
          fontSize='medium'
          tooltip={t('Tooltips.UserGroups.SaveUserGroupsTooltip')}
          onClick={onSave}
          disabled={
            !documentTemplate.documentTemplateXSignaturesChanged ||
            (documentTemplate.needsSigning && documentTemplate.documentTemplateXSignatures.length === 0)
          }
        />
      }
    >
      <DocumentTemplateSignatureHeaderComponent
        documentTemplate={documentTemplate}
        signatureTypes={signatureTypes}
        requiredDocTypes={requiredDocTypes}
        onSelectedClick={onSelectedClick}
        onImplicitClick={onImplicitClick}
        onPropertyChanged={onPropertyChanged}
        onDocumentTemplateNeedsSigningChanged={onDocumentTemplateNeedsSigningChanged}
        validation={validation}
      />
    </Card>
  );
};

DocumentTemplateSignatureHeaderCard.propTypes = {
  documentTemplate: PropTypes.object,
  signatureTypes: PropTypes.array.isRequired,
  requiredDocTypes: PropTypes.array.isRequired,
  onSelectedClick: PropTypes.func,
  onImplicitClick: PropTypes.func,
  onPropertyChanged: PropTypes.func,
  onSave: PropTypes.func,
  onDocumentTemplateNeedsSigningChanged: PropTypes.func,
  validation: PropTypes.object.isRequired
};

export default DocumentTemplateSignatureHeaderCard;
